import React from 'react';

const SaleTipBox = () => {
  return (
    <>
      <div className="flex overflow-hidden shadow-saleTipBox">
        <div className="w-1 shrink-0 self-stretch bg-gradient-to-b-linear-blue" aria-hidden />
        <div className="flex min-w-0 flex-1 flex-col gap-1 bg-gray-2 px-3 pt-2 pb-3">
          <div className="bg-blueGradient-blue-to-blue text-white text-xs font-bold py-1 px-2 rounded-md w-fit">
            판매 팁
          </div>
          <p className="text-gray-8 text-sm font-bold">지금 차량 금액을 낮추면 매물이 상단으로 노출 됩니다.</p>
          <p className="text-gray-6 text-xs font-semibold">
            빠른 판매를 위해서 최소 50만원 이상 낮추시는걸 권장드립니다.
          </p>
        </div>
      </div>
    </>
  );
};

export default SaleTipBox;
